jQuery(document).ready(function ($) {
    const ourOfferingsSlider = new Swiper('.our-offerings__carousel', {
        loop: true,

        slidesPerView: 1,

        longSwipes: false,

        spaceBetween: 40,

        pagination: {
            el: '.our-offerings__pagination',
            type: 'bullets',
            bulletClass: 'pagination__bullet',
            bulletActiveClass: 'active',
            clickable: true
        },

        autoplay: true,
        delay: 8000,

        breakpoints: {
            768: {
                slidesPerView: 2
            }
        }
    });
});